const AppConfig = {
  API_URL: process.env.REACT_APP_API_BASE_URL,
  LAMBDA_URL: process.env.REACT_APP_LAMBDA_BASE_URL,
};
export default AppConfig;
